module.exports = __webpack_public_path__ + "img/category-events.b96660c3.jpg";